import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import Loader from "../../components/Loader/Loader";
import ModalPlayer from "../../components/PlayerModal/playerModal";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import SubTabsComponent from "./newUx/subTabs/SubTabs";
import './Products.scss';

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

export default function Products({ ChangeShowDetailHandler }) {
  const navigate = useNavigate();
  const localData = useSelector((state) => state?.localStorage)
  const [loading, setLoading] = useState(true);
  const { micrositeID, tabConfigId } = localData
  const [activeKey] = useState("product");
  const [responseData, setResponseData] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const id = micrositeID;


  const getProductsData = async (activeKey, id) => {
    try {
      setLoading(true);
      if (id) {
        const response = await getRequest(
          userapiservice.getMicrositeDetailsTabs(id, tabConfigId)
        );
        setResponseData(response);
        setLoading(false);
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={error?.error || error?.message || 'Sorry, Something went wrong'} />)

      setLoading(false);
    }
  };

  const transformedData = responseData?.reduce((acc, item) => {
    const teamEntry = acc.find((entry) => entry.assetTitle === item?.assetTitle);
    const itemCopy = {
      ...item,
      id: item?.id,
      assetTitle: item?.assetTitle,
      subTitle: item?.subTitle,
      available: item?.available,
      description: item?.description,
      type: item?.type,
      mediaLink: {
        id: item?.mediaLink?.id,
        mediaType: item?.mediaLink?.mediaType,
        url: item?.mediaLink?.url,
        thumbnailUrl: item?.mediaLink?.thumbnailUrl,
      },
      urlLink: item?.urlLink,
      micrositeLogo: item?.micrositeLogo,
    };

    if (teamEntry) {
      teamEntry.subTitles.push(itemCopy);
    } else {
      acc.push({
        assetTitle: item?.assetTitle,
        subTitles: [itemCopy],
      });
    }

    return acc;
  }, []);

  const PlayVideoHandler = (url, mediaType) => {
    setMediaType(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf("youtu.be") !== -1) {
      const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  };

  const onCardClickHandler = (data, id) => {
    navigate(`/microsite/${data.id}/micrositeDetails`, {
      state: { page: activeKey, data: data },
    });
  };

  useEffect(() => {
    getProductsData(activeKey, id);
  }, [activeKey, id]);

  if (loading) {
    return (
      <Loader />
    )
  }
  else {
    return (
      <div
        className="background-container"  >
        {activeKey === "product" &&
          responseData &&
          responseData.length > 0 ? (
          <SubTabsComponent
            data={transformedData}
            PlayVideoHandler={PlayVideoHandler}
            color={color}
            convertToStandardURL={convertToStandardURL}
            handleCancel={handleCancel}
            isModalOpen={isModalOpen}
            mediaType={mediaType}
            onCardClickHandler={onCardClickHandler}
            videoUrl={videoUrl}
          />
        ) : (
          <div className="background-container" style={{ width: "100%" }}>
            <div className="login-wall">
              <div className="info-container">
                <span>No products available at the moment</span>
              </div>
            </div>
          </div>
        )}
        {isModalOpen && (
          <ModalPlayer
            closeModal={handleCancel}
            mediaLink={videoUrl}
            mediaType={mediaType}
          />
        )}
      </div>
    );
  }
}
